export default function MovingTruck() {
  return (
    <div className="relative h-20 w-full overflow-hidden bg-background-50 sm:h-24 md:h-28" aria-hidden="true">
      {/* Truck */}
      <div className="animate-truck-drive absolute bottom-0 left-0">
        <img
          src="/uploads/truck-lahari.png"
          alt=""
          className="block h-16 w-auto max-w-none sm:h-20 md:h-24"
        />
      </div>

      {/* Road — sits on the top edge of the grey block */}
      <div className="absolute inset-x-0 bottom-0 h-0.5 bg-background-300" />
      <div className="road-dash absolute inset-x-0 bottom-0 h-0.5" />
    </div>
  );
}